import { motion } from "framer-motion";

export const Float = ({ children, className = "", amp = 12, dur = 5, delay = 0 }) => (
  <motion.div
    className={className}
    animate={{ y: [0, -amp, 0], rotate: [0, 2.5, 0] }}
    transition={{ duration: dur, repeat: Infinity, ease: "easeInOut", delay }}
  >
    {children}
  </motion.div>
);

export const Smiley = ({ className = "", wink = false }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true">
    <circle cx="50" cy="50" r="44" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="5" />
    {wink ? (
      <path d="M29 45 Q37 36 45 45" stroke="#0A0A0A" strokeWidth="5" strokeLinecap="round" />
    ) : (
      <ellipse cx="37" cy="42" rx="5.5" ry="9" fill="#0A0A0A" transform="rotate(-8 37 42)" />
    )}
    <ellipse cx="63" cy="42" rx="5.5" ry="9" fill="#0A0A0A" transform="rotate(8 63 42)" />
    <path d="M34 63 Q50 76 66 63" stroke="#0A0A0A" strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export const Blob = ({ className = "" }) => (
  <svg viewBox="0 0 220 220" className={className} fill="none" aria-hidden="true">
    <path d="M170 120 C196 108 202 86 196 66" stroke="#0A0A0A" strokeWidth="9" strokeLinecap="round" />
    <circle cx="196" cy="58" r="11" fill="#3CE882" stroke="#0A0A0A" strokeWidth="5" />
    <path d="M189 44 L184 32 M197 42 L197 28 M205 46 L211 34" stroke="#0A0A0A" strokeWidth="4" strokeLinecap="round" />
    <path d="M106 40 C154 40 184 80 179 124 C174 166 144 192 104 192 C64 192 36 166 31 124 C26 80 58 40 106 40 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="6" />
    <ellipse cx="104" cy="160" rx="34" ry="19" fill="#3CE882" stroke="#0A0A0A" strokeWidth="4" />
    <path d="M84 22 L84 8 M106 18 L106 4 M128 22 L133 8" stroke="#0A0A0A" strokeWidth="4" strokeLinecap="round" />
    <circle cx="84" cy="86" r="21" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="5" />
    <circle cx="126" cy="86" r="21" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="5" />
    <circle cx="88" cy="90" r="6" fill="#0A0A0A" />
    <circle cx="122" cy="90" r="6" fill="#0A0A0A" />
    <path d="M62 122 Q105 140 148 122 C144 154 66 154 62 122 Z" fill="#0A0A0A" />
    <path d="M76 126 L89 129 L82 142 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M98 132 L111 132 L104.5 146 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M122 129 L135 126 L129 140 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="2.5" strokeLinejoin="round" />
  </svg>
);

export const Reader = ({ className = "" }) => (
  <svg viewBox="0 0 220 190" className={className} fill="none" aria-hidden="true">
    <rect x="80" y="14" width="60" height="26" rx="11" fill="#0A0A0A" />
    <rect x="80" y="31" width="60" height="8" fill="#3CE882" />
    <ellipse cx="110" cy="43" rx="42" ry="9" fill="#0A0A0A" />
    <circle cx="95" cy="58" r="8" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="4" />
    <circle cx="125" cy="58" r="8" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="4" />
    <circle cx="96" cy="59" r="2.6" fill="#0A0A0A" />
    <circle cx="126" cy="59" r="2.6" fill="#0A0A0A" />
    <rect x="40" y="68" width="140" height="94" rx="6" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="6" />
    <line x1="110" y1="74" x2="110" y2="156" stroke="#0A0A0A" strokeWidth="3" />
    <rect x="52" y="82" width="44" height="24" fill="#0A0A0A" />
    <rect x="122" y="82" width="44" height="24" fill="#3CE882" stroke="#0A0A0A" strokeWidth="3" />
    <path d="M52 118 H96 M52 128 H96 M52 138 H90 M122 118 H166 M122 128 H166 M122 138 H158" stroke="#0A0A0A" strokeWidth="3" strokeLinecap="round" />
    <circle cx="38" cy="92" r="9" fill="#3CE882" stroke="#0A0A0A" strokeWidth="5" />
    <circle cx="182" cy="92" r="9" fill="#3CE882" stroke="#0A0A0A" strokeWidth="5" />
  </svg>
);

export const Waver = ({ className = "" }) => (
  <svg viewBox="0 0 220 220" className={className} fill="none" aria-hidden="true">
    <path d="M78 152 C52 134 44 106 52 82" stroke="#0A0A0A" strokeWidth="14" strokeLinecap="round" />
    <circle cx="54" cy="70" r="13" fill="#3CE882" stroke="#0A0A0A" strokeWidth="5" />
    <path d="M45 54 L41 42 M55 50 L55 36 M66 54 L72 42" stroke="#0A0A0A" strokeWidth="4" strokeLinecap="round" />
    <path d="M70 220 L70 152 C70 118 150 118 150 152 L150 220 Z" fill="#0A0A0A" />
    <path d="M98 126 L110 142 L122 126" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M82 62 C82 38 138 38 138 62 L138 92 C138 114 82 114 82 92 Z" fill="#3CE882" stroke="#0A0A0A" strokeWidth="6" />
    <path d="M78 58 C70 22 150 22 142 58 C128 44 92 44 78 58 Z" fill="#0A0A0A" />
    <path d="M95 76 Q100 70 105 76 M117 76 Q122 70 127 76" stroke="#0A0A0A" strokeWidth="4" strokeLinecap="round" />
    <path d="M101 92 Q110 101 121 90" stroke="#0A0A0A" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const Croc = ({ className = "" }) => (
  <svg viewBox="0 0 290 135" className={className} fill="none" aria-hidden="true">
    {/* tail */}
    <path d="M10 88 C28 70 46 62 68 58 L68 98 C46 98 26 96 10 88 Z" fill="#3CE882" stroke="#0A0A0A" strokeWidth="6" strokeLinejoin="round" />
    {/* back leg */}
    <rect x="86" y="96" width="18" height="26" rx="9" fill="#3CE882" stroke="#0A0A0A" strokeWidth="5" />
    {/* body */}
    <path d="M62 62 C62 40 92 32 132 32 L184 32 C208 32 216 46 216 60 L216 76 C216 94 198 102 172 102 L106 102 C78 102 62 88 62 62 Z" fill="#3CE882" stroke="#0A0A0A" strokeWidth="6" strokeLinejoin="round" />
    {/* belly */}
    <ellipse cx="140" cy="92" rx="56" ry="9" fill="#F4F4F0" />
    {/* back spikes */}
    <path d="M92 34 L103 16 L114 34 Z" fill="#0A0A0A" />
    <path d="M128 32 L139 14 L150 32 Z" fill="#0A0A0A" />
    <path d="M164 33 L175 17 L186 33 Z" fill="#0A0A0A" />
    {/* mouth interior */}
    <path d="M208 68 L270 63 L270 77 L208 81 Z" fill="#0A0A0A" />
    {/* upper snout */}
    <path d="M210 46 L264 52 C277 54 277 67 264 68 L210 72 Z" fill="#3CE882" stroke="#0A0A0A" strokeWidth="6" strokeLinejoin="round" />
    {/* nostrils */}
    <circle cx="256" cy="58" r="2.6" fill="#0A0A0A" />
    <circle cx="266" cy="59" r="2.6" fill="#0A0A0A" />
    {/* upper teeth */}
    <path d="M218 67 L227 67 L222 77 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M240 66 L249 65 L245 75 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="2.5" strokeLinejoin="round" />
    {/* lower jaw — animated chomp */}
    <motion.g
      style={{ transformBox: "fill-box", transformOrigin: "0% 50%" }}
      animate={{ rotate: [0, 0, 17, 0, 0, 17, 0, 0] }}
      transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
    >
      <path d="M210 76 L262 72 C273 72 273 82 261 84 L210 88 Z" fill="#3CE882" stroke="#0A0A0A" strokeWidth="6" strokeLinejoin="round" />
      <path d="M224 76 L232 75 L228 67 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M246 74 L254 73 L250 66 Z" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="2.5" strokeLinejoin="round" />
    </motion.g>
    {/* eye bump */}
    <circle cx="216" cy="34" r="14" fill="#3CE882" stroke="#0A0A0A" strokeWidth="6" />
    <circle cx="216" cy="34" r="7" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="3" />
    <circle cx="218" cy="35" r="3.4" fill="#0A0A0A" />
    {/* front leg */}
    <rect x="180" y="96" width="18" height="26" rx="9" fill="#3CE882" stroke="#0A0A0A" strokeWidth="5" />
    {/* claws */}
    <path d="M88 122 L96 122 M182 122 L190 122" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
  </svg>
);
